// extracted by mini-css-extract-plugin
export default {"container":"styles_container__J7nlF","label":"styles_label__J9iQ2"};